export enum AudioStatus {
  NotStarted = 'NotStarted',
  InProgress = 'InProgress',
  Success = 'Success',
  Error = 'Error',
  InQueue = 'InQueue',
}

export interface AudioDialogEntry {
  id: string;
  dialog: string;
}

export interface IAudioCreation {
  id: string;
  name: string;
  userId: string;
  userAudioTrackId?: string;
  speechContentId?: string;
  status: AudioStatus;
  processedURL?: string;
  sharedWith?: string[];
  isCreationAudio: boolean;
  createdAt: string;
  updatedAt: string;
  isAlreadyExists?: boolean;
  audioDialogMap?: AudioDialogEntry[];
  speed?: number;
}

export interface DropdownMenuAction {
  id: string;
  label: string;
  onClick: (data?: any) => void;
  iconifyIcon: string;
  imageIcon?: string;
}

export enum AudioTab {
  Private = 0,
  Public = 1,
}

export enum TEXT_TO_SPEECH_STAGE {
  PROMPT_INPUT = 'PROMPT_INPUT',
  CREDITS_CHECK = 'CREDITS_CHECK',
  GENERATING = 'GENERATING',
}
